const user = {
  namespaced: true,
  state: {
    userInfo: {}
  },
  mutations: {
    set_userInfo(state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    SET_USERINFO({ commit }, data) {
      commit('set_userInfo', data)
    },
  }
}

export default user